import {useQueryClient, useMutation} from 'react-query'
import {QUERIES} from '../../../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {useQueryResponse} from '../../core/QueryResponseProvider'
import {deleteSelectedData} from '../../core/_requests'
import {toast} from 'react-toastify' 


const ListGrouping = () => {
  const {selected, clearSelected} = useListView()
  const queryClient = useQueryClient()
  const {query, refetch} = useQueryResponse()

  const deleteSelectedItems = useMutation(() => deleteSelectedData(selected), {
    onSuccess: () => {
      queryClient.invalidateQueries([`${QUERIES.TICKET_LIST}-${query}`])
      refetch()
      toast.success('Tickets deleted successfully')
      clearSelected()
    },
    onError: () => {
      toast.error('Failed to delete tickets')
    }
  })

  const handleConfirmDelete = () => {
    if (window.confirm(`Are you sure you want to delete ${selected.length} selected tickets?`)) {
      deleteSelectedItems.mutate()
    }
  }

  return (
    <div className='d-flex justify-content-end align-items-center'>
      <div className='fw-bolder me-5'>
        <span className='me-2'>{selected.length}</span> Selected
      </div>

      <button
        type='button'
        className='btn btn-danger'
        onClick={handleConfirmDelete}
        disabled={deleteSelectedItems.isLoading}
      >
        {deleteSelectedItems.isLoading ? (
          <span className='spinner-border spinner-border-sm align-middle me-2'></span>
        ) : (
          'Delete Selected'
        )}
      </button>
    </div>
  )
}

export {ListGrouping}